/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description antd constants
 */

/**
 * CLASS_NAMES
 * @description custom antd classes
 */
const CLASS_NAMES = {
	secondaryButton: 'ant-secondary-button',
	formilyErrorItem: 'ant-formily-item-error',
	modalConfirmSubtitle: 'ant-modal-confirm-subtitle',
};

/**
 * ANT_TAG_COLORS
 * @type {string}
 */
const ANT_TAG_COLORS = {
	magenta: 'magenta',
	red: 'red',
	volcano: 'volcano',
	orange: 'orange',
	gold: 'gold',
	lime: 'lime',
	green: 'green',
	cyan: 'cyan',
	blue: 'blue',
	geekblue: 'geekblue',
	purple: 'purple',
	processing: 'processing',
	error: 'error',
	success: 'success',
	warning: 'warning',
	default: 'default',
};

const ANTD_PAGE_CONTAINER_CLASS = 'ant-pro-page-container-children-container';

/**
 * ANT_FORMILY_FORM_WRAPPER_CLASS
 * @type {string}
 */
const ANT_FORMILY_FORM_WRAPPER_CLASS = 'formily-form-wrapper';

const ANT_FORMILY_CARD_CLASS = 'formily-field-card';

// TODO: remove this constant
const DEFAULT_PAGE_SPINNER_TOP = 88;

export {
	CLASS_NAMES as AntClass,
	ANT_TAG_COLORS,
	ANTD_PAGE_CONTAINER_CLASS,
	ANT_FORMILY_FORM_WRAPPER_CLASS,
	ANT_FORMILY_CARD_CLASS,
	DEFAULT_PAGE_SPINNER_TOP,
};
